export default __webpack_public_path__ + "static/media/ic-image-studio-black.0aac18e1.svg";